type ScrollLockTarget = {
  style: {
    overflow: string;
  };
};

export const lockBodyScroll = (body: ScrollLockTarget): (() => void) => {
  const previousOverflow = body.style.overflow;
  body.style.overflow = "hidden";

  return () => {
    body.style.overflow = previousOverflow;
  };
};
